<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">

    <!-- <h3>{{questionText}}</h3> -->

    <v-text-field 
      placeholder="Write your answer here" 
      prepend-icon="textsms"
      v-model="selected">
    </v-text-field>

  </v-flex>

</template>

<script>
// @ is an alias to /src

export default {
  name: "textbox",
  components: {
  },
  props: {
    question: Object
  },
  data: () => ({
    selected: null
  }),
  computed: {
    questionText() {
      return this.question.text;
    }
  },
  watch: {
    selected() {
      const arg = {
        questionObj : this.question,
        answer : this.selected
      };
      this.$store.commit('setAnswerForQuestionObj', arg);
    }
  },
  created(){},
  methods: {}
};
</script>

<style scoped>

</style>